import React from 'react';
import { Box, Snackbar, Alert, Slide } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNotification } from '../../contexts/NotificationContext';

const SlideTransition = (props) => {
  return <Slide {...props} direction="left" />;
};

const AdminNotificationContainer = () => {
  const { notifications, removeNotification } = useNotification();
  const theme = useTheme();

  const getNotificationProps = (type) => {
    // 'primary' is a legacy alias for the brand-colored toast. Everything else
    // maps straight to a MUI severity so colors + shape come from the shared
    // theme (palette + MuiAlert filled override) — keeping all toasts identical.
    if (type === 'primary') {
      return {
        severity: 'info',
        sx: {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          '& .MuiAlert-icon': { color: theme.palette.primary.contrastText },
          '& .MuiAlert-action': { color: theme.palette.primary.contrastText },
        },
      };
    }

    return { severity: type };
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        maxWidth: 420,
        pointerEvents: 'none', // Allow clicks to pass through the container
      }}
    >
      {notifications.map((notification, index) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={null} // We handle auto-hide in context
          onClose={() => removeNotification(notification.id)}
          TransitionComponent={SlideTransition}
          sx={{
            position: 'relative',
            transform: 'none !important',
            marginBottom: index > 0 ? 1.5 : 0,
            pointerEvents: 'auto', // Re-enable pointer events for the actual notification
          }}
        >
          <Alert
            onClose={() => removeNotification(notification.id)}
            {...getNotificationProps(notification.type)}
            variant="filled"
            sx={{
              width: '100%',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.16)',
              },
              ...getNotificationProps(notification.type).sx
            }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </Box>
  );
};

export default AdminNotificationContainer;
